<template>
  <div id="app" class="min-h-screen flex flex-col">
    <TheHeader v-if="!isFullscreen" />
    <router-view class="flex-1" />
    <TheFooter v-if="!isFullscreen" />
    <WhatsAppButton v-if="!isFullscreen" />
  </div>
</template>

<script>
import TheHeader from '@/components/layout/TheHeader.vue';
import TheFooter from '@/components/layout/TheFooter.vue';
import WhatsAppButton from '@/components/ui/WhatsAppButton.vue';

export default {
  name: 'App',
  components: {
    TheHeader,
    TheFooter,
    WhatsAppButton
  },
  computed: {
    isFullscreen() {
      return this.$route && this.$route.meta && this.$route.meta.fullscreen;
    }
  }
};
</script>
